import React from 'react';
import Dropzone from 'react-dropzone';
import { FormattedMessage } from 'react-intl';

import PropTypes from 'prop-types';

import API from '@/apiRequest';
import classes from '@/inspectionAttach/InspectionFile.module.css';

class InspectionFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
      fileName: null,
    };
    this.onDropAccepted = this.onDropAccepted.bind(this);
  }

  /*
    Function call when the file dropped is accepted
  */
  onDropAccepted(files) {
    const { orderAttachFile } = this.props;
    const file = files[0];
    const fileExtension = file.name.split('.').pop();

    this.setState({ uploading: true, fileName: file.name });

    API.get('/upload')
      .then(res => {
        fetch(res.data.url, {
          method: 'PUT',
          contentType: 'binary/octet-stream',
          processData: false,
          body: file,
        })
          .then(response => {
            if (response.ok) {
              orderAttachFile(fileExtension, file.name, res.data.remote_name);
            }
          })
          .catch(ex => {
            console.log('parsing failed', ex);
            this.setState({ uploading: false, fileName: null });
          });
      })
      .catch(error => {
        console.log(error);
        this.setState({ uploading: false, fileName: null });
      });
  }

  render() {
    const { previousType } = this.props;
    const { uploading, fileName } = this.state;

    if (uploading) {
      return (
        <div className={classes.Dropzone}>
          <div className={classes.content}>
            <span className={classes.title}>
              <FormattedMessage id="inspectionAttach.file" values={{ type: previousType.toLowerCase() }} />
            </span>
            <div className={classes.uploadingRow}>
              <div className={classes.spinner} />
              <div className={classes.uploadingInfo}>
                <span className={classes.uploadingFileName}>{fileName}</span>
                <span className={classes.uploadingText}>
                  <FormattedMessage id="uploading" defaultMessage="Enviando..." />
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <Dropzone
        className={classes.Dropzone}
        accept="application/pdf"
        multiple={false}
        onDropAccepted={this.onDropAccepted}
        data-cy="inspection-attach-input"
      >
        <div className={classes.content}>
          <span className={classes.title}>
            <FormattedMessage id="inspectionAttach.file" values={{ type: previousType.toLowerCase() }} />
          </span>
          <div className={classes.row}>
            <button type="button">
              <FormattedMessage id="select" />
            </button>
            <span className={classes.hint}>
              <FormattedMessage id="inspectionAttach.drop" />
            </span>
          </div>
        </div>
      </Dropzone>
    );
  }
}

InspectionFile.propTypes = {
  /**
   * Function to pass the selected inspection
   */
  orderAttachFile: PropTypes.func.isRequired,
  previousType: PropTypes.string.isRequired,
};

export default InspectionFile;
